/**
 * The per-row entrance delay, capped. Derived from the row index, so an unpaginated table would
 * otherwise put the last row seconds behind the first and read as a page still loading.
 */

/** Rows past this one all animate together. */
const MAX_STAGGERED_ROWS = 15;

export function staggerDelay(index: number, step: number, reduceMotion: boolean | null): number {
  if (reduceMotion) return 0;
  return Math.min(index, MAX_STAGGERED_ROWS) * step;
}
